import React from 'react';
import Flagship from '../../core/flagship';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Field from './Field';
import {getFormattedValue, empty} from '../../utils/helpers';
import '../../styles/singleRecord.scss';
import { Divider, Header, Button, Label, Icon, Modal } from 'semantic-ui-react';

class SingleRecordField extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.editField = this.editField.bind(this);
        this.saveField = this.saveField.bind(this);
        this.stopEditing = this.stopEditing.bind(this);
    }

    getInitialState() {
        return {
            editing: false,
            inputValue: this.props.field_value,
            errors:[]
        }

    }

    editField(fieldId) {
        this.setState({ editing: fieldId });
    }

    saveField(e, fieldId) {

        let self = this;

        let recordId = this.props.recordId;
        let userId = this.props.userId;
        let afterSave = (typeof this.props.afterSave === "function" ? this.props.afterSave : function() {});

        let requestData = {
            value: this.state.inputValue
        };
        let label = this.props.label;


        Flagship.post(
            'save-record/' + recordId + "/" + fieldId,
            requestData,
            function (response) {
                if (response.data.success === true) {

                    if(response.data.updated === true ) {
                        // Updated value in DB

                        Flagship.event("change",
                            {
                                "label": label,
                                "new": requestData.value,
                                "old": response.data.oldValue
                            },
                            recordId,
                            userId
                        );
                        afterSave();

                        self.setState({
                            editing: false,
                            inputValue: requestData.value,
                            errors: []
                        });

                        Flagship.notify("Field saved.");
                    }

                } else {
                    Flagship.error("Error updating field #" + fieldId + ".", recordId, userId);
                }
            },
            function(err) {
                Flagship.error("Error updating field #" + fieldId + ": " + err, recordId, userId);
            }
        );

    }

    updateInputValue(value) {
        this.setState({
            inputValue: value
        });
    }

    stopEditing() {
        this.setState({
            editing: false,
            inputValue: this.props.field_value,
            errors: []
        });
    }


    addError(fieldId) {

        let errors = this.state.errors;

        if (errors.indexOf(fieldId) === -1) {
            errors.push(fieldId);
        }

        this.setState({
            errors: errors
        });
    }

    clearError(fieldId) {

        let errors = this.state.errors;
        for (var i = errors.length - 1; i >= 0; i--) {
            if (errors[i] === fieldId) {
                errors.splice(i, 1);
            }
        }

        this.setState({
            errors: errors
        });
    }


    renderValue(value) {
        if( Array.isArray(value)) {
            return value.map(function(val, i) {
                return (
                   <div key={"field-value-" + i}>
                       {val}
                   </div>
                );
            });
        } else {
            return value;
        }
    }

    render() {

        let item = this.props;

        if ( this.props.readOnly === true ) {
            return (
                <div key={item.id} className="single-record-single-field">
                    <Label>{item.label}</Label>
                    <div className="field-value">
                        {this.renderValue(getFormattedValue(item.field_value, item.validation))}
                    </div>
                </div>
            );
        }

        let editField = this.editField;
        if (item.field_value !== "") {
            const updateModalValue = (e, value) => {
                this.updateInputValue(value);
            };

            if ( item.field_value !== "" && item.field_value !== null ) {
                let trigger =
                    <div key={item.id} className="single-record-single-field">
                        <Label className="edit-corner-icon"
                               size="large"
                               corner="right"
                               onClick={() => {editField(item.field_id)}}>
                            <Icon className="edit-corner-icon-icon" name="edit"/>
                        </Label>
                        <Label>{item.label}</Label>
                        <div className="field-value">
                            {this.renderValue(getFormattedValue(item.field_value, item.validation))}
                            {!empty(item.suffix) ? ' ' + item.suffix : ''}
                        </div>
                    </div>;

                return (
                    <Modal
                        key={item.key}
                        trigger={trigger}
                        closeIcon
                        open={this.state.editing === item.field_id}
                        onClose={this.stopEditing.bind(this)}
                    >
                        <Modal.Content>
                            <Header>Edit Information</Header>
                            <Field
                                addError={this.addError.bind(this)}
                                clearError={this.clearError.bind(this)}
                                model={ "editRecord." + item.field_id }
                                value={this.state.inputValue}
                                onChange={(e, field, id) => updateModalValue(e, field, id)}
                                {...item}
                            />
                            <Divider />
                            <Button disabled={this.state.errors.length ? true : false } onClick={(e) => this.saveField(e, item.field_id, item.field_value)} primary>
                                Save
                            </Button>
                            <Button onClick={this.stopEditing} >
                                Cancel
                            </Button>
                        </Modal.Content>
                    </Modal>
                );
            } else {
                return null;
            }
        }
        return null;
    }
}

SingleRecordField.propTypes = {
    niceName: PropTypes.string,
    username: PropTypes.string,
    userId: PropTypes.number
};

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId
  };
}

export default connect(
  mapStateToProps,
  null
)(SingleRecordField);





// WEBPACK FOOTER //
// ./src/components/records/SingleRecordField.js